import { useCallback } from "react";
import { Image } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { useModal } from "@ludens-reklame/react-modal";
import {
  Constrainer,
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { Card, Content, Grid, Heading, Menu } from "./styles.js";
import { ShowcaseModal } from "./ShowcaseModal.js";

export interface Showcase {
  title?: string;
  text?: string;
  images?: { image?: Image }[];
}

export interface Props {
  cases?: Showcase[];
}

export const Showcases: React.FunctionComponent<Props> = ({ cases = [] }) => {
  const { spawnModal } = useModal();

  const openCase = useCallback(
    (index: number) => {
      spawnModal(<ShowcaseModal initialIndex={index} cases={cases} />);
    },
    [spawnModal, cases]
  );

  if (cases.length === 0) {
    return null;
  }

  return (
    <VerticalSpacer>
      <HorizontalSpacer>
        <Constrainer>
          <Heading>
            <h2>Referanseprosjekter</h2>
            <select
              className="mobile"
              value=""
              tabIndex={-1}
              onChange={(e) => {
                openCase(parseInt(e.target.value));
              }}
            >
              <option value="" disabled>
                Velg et prosjekt
              </option>
              {cases.map((c, k) => (
                <option key={k} value={k}>
                  {c.title}
                </option>
              ))}
            </select>
          </Heading>
          <Content>
            <Menu className="desktop">
              {cases.map((c, k) => (
                <li key={k}>
                  <a
                    href="#"
                    aria-label={`Åpne referanseprosjekt ${c.title}`}
                    tabIndex={-1}
                    onClick={(e) => {
                      e.preventDefault();
                      openCase(k);
                    }}
                  >
                    {c.title}
                  </a>
                </li>
              ))}
            </Menu>
            <Grid>
              {cases.map((c, k) => {
                const primaryImage = c.images?.[0]?.image;

                return (
                  <Card
                    key={k}
                    $image={primaryImage?.transforms["h_600"] || ""}
                    href="#"
                    aria-label={`Åpne referanseprosjekt ${c.title}`}
                    onClick={(e) => {
                      e.preventDefault();
                      openCase(k);
                    }}
                  >
                    {c.title && <h3 className="h6">{c.title}</h3>}
                  </Card>
                );
              })}
            </Grid>
          </Content>
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};
